import { useTranslation } from 'react-i18next';
import { Crown } from 'lucide-react';
import { RevenueEvolutionWidget } from '@/components/dashboard/RevenueEvolutionWidget';
import { CustomerFlowWidget } from '@/components/dashboard/CustomerFlowWidget';
import { GrowthQualityWidget } from '@/components/dashboard/GrowthQualityWidget';
import { PredictabilityWidget } from '@/components/dashboard/PredictabilityWidget';
import { PipelineTemperatureWidget } from '@/components/dashboard/PipelineTemperatureWidget';
import { ForecastSummaryWidget } from '@/components/dashboard/ForecastSummaryWidget';

/**
 * Story 58.5 — Board Revenue Dashboard ("The Revenue Room").
 *
 * Owner / Presidente layout. Single-page narrative: revenue evolution
 * + projection at the top (the headline), then the temperature + the
 * forecast (current state), then the unit-economics-adjacent panels
 * (customer flow + growth quality + predictability).
 *
 * Reuses widgets from epic 57 + 56 — boardroom narrative, not new
 * widgets. Distinct layout from /dashboard so an exec can land here
 * without operational noise.
 */
export function CockpitBoardPage() {
  const { t } = useTranslation();
  return (
    <div className="space-y-6 p-6">
      <header className="flex items-center gap-3">
        <Crown className="h-5 w-5 text-muted-foreground" />
        <div>
          <h1 className="text-2xl font-semibold">{t('cockpitBoard.title')}</h1>
          <p className="text-sm text-muted-foreground">{t('cockpitBoard.subtitle')}</p>
        </div>
      </header>

      <RevenueEvolutionWidget />

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <PipelineTemperatureWidget />
        <ForecastSummaryWidget />
      </div>

      <CustomerFlowWidget />

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <GrowthQualityWidget />
        <PredictabilityWidget />
      </div>
    </div>
  );
}
